import SelectProductSettleIn from "./-selection";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/review/selection")({
  staticData: {
    menuLabel: "选品入驻",
    showInMenu: true,
    menuGroup: "/review",
    menuOrder: 1,
  },
  component: SelectProductSettleIn,
});
